module.exports = __webpack_public_path__ + "img/logo.6a005ec6.png";